import { StyleSheet } from 'react-native';
import FontFamily from '../../../../constants/fonts';

export const msStyles = StyleSheet.create({
  container: { marginBottom: 4 },
  label: { fontSize: 14, fontWeight: '600', color: '#454545', marginBottom: 4, fontFamily: FontFamily.medium },
  trigger: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 5,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: '#FFFFFF',
    minHeight: 42,
  },
  triggerText: { flex: 1, fontSize: 14, color: '#212529', fontFamily: FontFamily.regular },
  placeholder: { color: '#6C757D' },
  backdrop: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 },
  menu: {
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 9999,
  },
  searchBox: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  searchInput: { flex: 1, fontSize: 13, color: '#212529', fontFamily: FontFamily.regular, paddingVertical: 2 },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  optionSelected: { backgroundColor: '#EAF4FF' },
  optionText: { fontSize: 14, color: '#212529', fontFamily: FontFamily.regular, flex: 1 },
});

export const styles = StyleSheet.create({
  overlayWrapper: {
    flex: 1,
    flexDirection: 'column',
  },
  scrollContent: {
    flex: 1,
  },
  overlayContent: {
    padding: 20,
  },
  overlayFooter: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  saveErrorBox: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFEBEE',
    borderRadius: 4,
    borderLeftWidth: 3,
    borderLeftColor: '#C62828',
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginBottom: 12,
  },
  saveErrorText: {
    fontSize: 13,
    color: '#C62828',
    fontFamily: FontFamily.regular,
    flex: 1,
  },
  footerButtons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
  footerButtonsMobile: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    width: '100%',
  },
  footerButtonFlex: {
    flex: 1,
    minWidth: 0,
  },
  assessmentSection: {
    flexDirection: 'column',
  },
  sectionTitleContainer: {
    borderBottomWidth: 2,
    borderBottomColor: '#DAEEFA',
    paddingBottom: 12,
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#2D2D2D',
    fontFamily: FontFamily.bold,
  },
  inputGroup: {
    marginBottom: 14,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
    flex: 1,
    flexWrap: 'wrap',
  },
  greyText: {
    color: '#999999',
    fontWeight: '200',
  },
  labelRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 6,
    flexWrap: 'wrap',
    gap: 4,
  },
  fieldLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
    flex: 1,
    flexWrap: 'wrap',
  },
  requiredLabel: {
    fontSize: 12,
    color: 'rgb(108, 117, 125)',
    fontFamily: FontFamily.regular,
    marginLeft: 4,
    flexShrink: 0,
  },
  inputWrapper: {
    borderWidth: 1,
    borderColor: '#D0D0D0',
    borderRadius: 5,
  },
  inputError: {
    borderColor: '#C62828',
    borderWidth: 1,
    backgroundColor: '#FFF5F5',
  },
  textInput: {
    fontSize: 14,
    color: '#2D2D2D',
    fontFamily: FontFamily.regular,
    paddingVertical: 8,
    paddingHorizontal: 10,
    minHeight: 80,
  },
  charCount: {
    fontSize: 11,
    color: '#999999',
    fontFamily: FontFamily.regular,
    marginTop: 2,
    textAlign: 'right',
  },
  charCountRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 4,
    flexWrap: 'wrap',
    gap: 4,
  },
  inputLocked: {
    backgroundColor: '#F5F5F5',
    borderColor: '#D0D0D0',
  },
  lockedHelperText: {
    fontSize: 11,
    color: '#999999',
    fontFamily: FontFamily.regular,
    fontStyle: 'italic',
    flex: 1,
  },
  questionFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: 6,
    flexWrap: 'wrap',
    gap: 4,
  },
  usageText: {
    fontSize: 12,
    color: '#999999',
    fontFamily: FontFamily.regular,
    flex: 1,
    flexWrap: 'wrap',
  },
  sharedAttributesSection: {
    flexDirection: 'column',
    marginTop: 10,
    overflow: 'visible',
  },
  dropdownRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
    overflow: 'visible',
  },
  dropdownRowSingle: {
    flexDirection: 'column',
    marginBottom: 0,
    overflow: 'visible',
  },
  sectionError: {
    borderWidth: 1,
    borderColor: '#C62828',
    borderRadius: 8,
    padding: 8,
    backgroundColor: '#FFF5F5',
  },
  dropdownColumn: {
    flex: 1,
    marginRight: 8,
    overflow: 'visible',
  },
  dropdownColumnSingle: {
    width: '100%',
    marginRight: 0,
    marginBottom: 12,
    overflow: 'visible',
  },
  dropdownErrorWrapper: {
    borderWidth: 1,
    borderColor: '#C62828',
    borderRadius: 6,
    padding: 4,
    backgroundColor: '#FFF5F5',
  },
  moduleAssignmentSection: {
    flexDirection: 'column',
    marginTop: 20,
  },
  moduleErrorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 6,
  },
  moduleErrorText: {
    fontSize: 12,
    color: '#C62828',
    fontFamily: FontFamily.regular,
  },
  checkboxGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  checkboxColumn: {
    flex: 1,
    flexDirection: 'column',
  },
  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
    marginRight: 8,
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderColor: '#E8E8E8',
    borderRadius: 5,
    backgroundColor: '#FAFAFA',
  },
  checkbox: {
    marginRight: 10,
  },
  checkboxLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
  },
  infoBox: {
    backgroundColor: '#DAEEFA',
    borderRadius: 5,
    borderLeftWidth: 4,
    borderLeftColor: '#034895',
    padding: 12,
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  infoIcon: {
    marginRight: 12,
    marginTop: 2,
    flexShrink: 0,
  },
  infoText: {
    fontSize: 13,
    color: '#01346F',
    lineHeight: 20,
    fontFamily: FontFamily.regular,
    flex: 1,
    flexWrap: 'wrap',
  },
  attributesSection: {
    backgroundColor: '#E8E8F8',
    borderRadius: 8,
    padding: 16,
    marginTop: 20,
    borderLeftWidth: 4,
    borderLeftColor: '#034895',
  },
  attributesSectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#034895',
    marginBottom: 16,
    fontFamily: FontFamily.bold,
  },
  attributeRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  attributeRowSingle: {
    flexDirection: 'column',
    marginBottom: 0,
  },
  attributeColumn: {
    flex: 1,
    marginRight: 8,
  },
  attributeColumnSingle: {
    width: '100%',
    marginRight: 0,
    marginBottom: 12,
  },
  shiftHandoverSection: {
    backgroundColor: '#D4E8F7',
    borderLeftColor: '#0066CC',
  },
  leadershipWalkSection: {
    backgroundColor: '#C8E6C9',
    borderLeftColor: '#2E7D32',
  },
  leadershipWalkSectionDark: {
    backgroundColor: '#15301A',
    borderLeftColor: '#2E7D32',
  },
  sparcWalkSection: {
    backgroundColor: '#F5DEB3',
    borderLeftColor: '#8B4513',
  },
  sparcWalkSectionDark: {
    backgroundColor: '#352515',
    borderLeftColor: '#C67A32',
  },
  nhoSection: {
    backgroundColor: '#FFF9C4',
    borderLeftColor: '#F57F17',
  },
  nhoSectionDark: {
    backgroundColor: '#3A2E12',
    borderLeftColor: '#F57F17',
  },
  rackingInspectionSection: {
    backgroundColor: '#E1BEE7',
    borderLeftColor: '#6A1B9A',
  },
  rackingInspectionSectionDark: {
    backgroundColor: '#2A1736',
    borderLeftColor: '#AB47BC',
  },
  siteEvaluationSection: {
    backgroundColor: '#FFCCBC',
    borderLeftColor: '#D84315',
  },
  siteEvaluationSectionDark: {
    backgroundColor: '#381C15',
    borderLeftColor: '#FF7043',
  },
  statusRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    paddingVertical: 10,
    paddingHorizontal: 14,
    backgroundColor: '#F5F9FF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D0D9E8',
  },
  statusLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
    marginRight: 10,
  },
  statusValue: {
    fontSize: 14,
    fontWeight: '600',
    fontFamily: FontFamily.medium,
    marginLeft: 10,
  },
});
